import template from './pD365ProcessConfig.html';

export function pD365ProcessConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pD365ProcessConfigController,
    controllerAs: 'pD365ProcessConfig',
    bindToController: true
  };

  return directive;
}

class pD365ProcessConfigController {
  constructor($scope, $location, $interval, $routeParams, $q, Auth, D365, Notes, Sort, Utils, bModal) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$routeParams = $routeParams;
    this.$q = $q;
    this.Auth = Auth;
    this.D365 = D365;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.bModal = bModal;
    this.state = "loading";
    this.processGroupId = this.$routeParams.processGroupId;
    this.processGroupName = decodeURIComponent(this.$routeParams.processGroupName);

    this.headers = [
      {name: "D365.PROCESS_KLIX", class: "table-info"},
      {name: "D365.WBS_ELEMENT", class: "table-d365"},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.getData();
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  backToPGs() {
    window.history.back();
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.processMatch = null;
  }

  getData() {
    this.D365.getProcessesMappers(this.processGroupId).then(
      (success) => {
        this.processesKlix = success.data.processes.sort(this.Sort.abcBy("name"));
        this.d365Processes = success.data.d365Processes
          .sort(this.Sort.abcBy("name"))
          .map(processD365 => {
            processD365.info = processD365.name;
            return processD365;
          });

        this.mapperToDisplay = this.processesKlix && this.processesKlix.map( pKlix => {
          let client = this.processesMapper && this.processesMapper.find(pMapper => pMapper.taskId == pKlix.id);
          if(!client) {
            client = {processId: pKlix.id , processName: pKlix.name, d365ProcessId: pKlix.d365ProcessId, d365ProcessName: pKlix.d365ProcessName, unmatched: !pKlix.d365ProcessId, d365Active: pKlix.d365Active};
          }
          return client;
        });
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  editMatch(entity) {
    this.processMatch = {name: entity.d365ProcessName};
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
  }

  saveMapper(process, d365Process) {
    this.state = "loading";
    this.D365.saveProcessMapper(
      process.processId,
      angular.fromJson(d365Process).taskId,
      angular.fromJson(d365Process).hierarchyId,
      angular.fromJson(d365Process).name
    ).then(
      () => {
        this.processMatch = null;
        this.matchBlocked = false;
        this.getData();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteMatch(mapper) {
    this.state = "loading";
    this.D365.deleteProcessMapper(mapper.processId).then(
      () => {
        this.getData();
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}